<div [class]="props.class">
  {{ props.description }}
</div>

<ng-container #fieldComponent></ng-container>
